import React from 'react';
import { Pagination, Box } from '@mui/material';

interface PaginationControlsProps {
  get_total_parcel_count: number;
  limit: number;
  setLimit: (value: number) => void;
  sortBy: string;
  setSortBy: (value: string) => void;
  get_page_no: number;
  set_page_no: (value: number) => void;
}

const PaginationControls: React.FC<PaginationControlsProps> = ({
  get_total_parcel_count,
  limit,
  setLimit,
  sortBy,
  setSortBy,
  get_page_no,
  set_page_no,
}) => {
  return (
    <div className="flex flex-col md:flex-row w-full justify-between p-2 space-y-4 md:space-y-0 md:items-center">
      <div className="flex justify-center md:justify-start">
        <Pagination
          color="primary"
          count={Math.ceil(get_total_parcel_count / limit)}
          variant="outlined"
          shape="rounded"
          page={get_page_no}
          onChange={(e, page) => {
            set_page_no(page);
          }}
        />
      </div>
      <Box className="flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-4">
        <div className="flex flex-row items-center space-x-4 w-full md:w-auto">
          <div className="flex items-center space-x-2">
            <label htmlFor="limit" className="text-sm font-medium">
              Set limit:
            </label>
            <select
              onChange={(e) => {
                const parsedLimit = parseInt(e.target.value, 10);
                setLimit(parsedLimit);
                localStorage.setItem('limitMerchant', JSON.stringify(parsedLimit));
              }}
              className="cursor-pointer p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              defaultValue={limit}
            >
              <option value={10}>10</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={150}>150</option>
              <option value={250}>250</option>
              <option value={500}>500</option>
              <option value={1000}>1000</option>
            </select>
          </div>
          <div className="flex items-center space-x-2">
            <label htmlFor="sort" className="text-sm font-medium">
              Sort by:
            </label>
            <select
              value={sortBy}
              onChange={(e) => {
                setSortBy(e.target.value);
                localStorage.setItem('sortMerchant', JSON.stringify(e.target.value));
              }}
              className="cursor-pointer p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value={'id:ASC'}>Old to New</option>
              <option value={'id:DESC'}>New to Old</option>
              <option value={'updated_at:DESC'}>Last Update</option>
            </select>
          </div>
        </div>
      </Box>
    </div>
  );
};

export default PaginationControls;
